import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getCollections } from "../services/collection.service";

// 🔹 Fetch ALL collections
export const fetchCollections = createAsyncThunk(
  "collections/fetchCollections",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getCollections();
      return response?.data?.data || { collections: [], categories: [] };
    } catch (err) {
      return rejectWithValue(
        err?.response?.data?.message || "Failed to fetch collections"
      );
    }
  }
);

const collectionsSlice = createSlice({
  name: "collections",
  initialState: {
    items: {
      collections: [],
      categories: [],
    },
    loading: false,
    error: null,
  },
  reducers: {
    clearCollections: (state) => {
      state.items = { collections: [], categories: [] };
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCollections.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCollections.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchCollections.rejected, (state, action) => {
        state.loading = false;
        state.items = { collections: [], categories: [] };
        state.error = action.payload || action.error.message;
      });
  },
});

export const { clearCollections } = collectionsSlice.actions;
export default collectionsSlice.reducer;
